/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Consent_TitleInputs */

const en_mcp_connect_consent_title = /** @type {(inputs: Mcp_Connect_Consent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connect ${i?.app} to Listening`)
};

const es_mcp_connect_consent_title = /** @type {(inputs: Mcp_Connect_Consent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conecta ${i?.app} a Listening`)
};

/**
* | output |
* | --- |
* | "Connect {app} to Listening" |
*
* @param {Mcp_Connect_Consent_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_consent_title = /** @type {((inputs: Mcp_Connect_Consent_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Consent_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_consent_title(inputs)
	return en_mcp_connect_consent_title(inputs)
});